import { render } from "./liquidity-mining.vue?vue&type=template&id=3861f76c&ts=true"
import script from "./liquidity-mining.vue?vue&type=script&lang=ts"
export * from "./liquidity-mining.vue?vue&type=script&lang=ts"

import "./liquidity-mining.vue?vue&type=style&index=0&id=3861f76c&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__